export default class RegisterLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_registerLayer';
  }

  open() {
    this.render();
    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: false,
        bUseHistorybackOnClose: false,
        bShowDimmed: false,
      });
      TMON.oApp.oUtil.setPositioningCenterOnPc(
        TMON.oApp.htStorage.htLastOpenLayer.welLastOpenLayer
      );
    } else {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
    }
  }

  render() {
    $(`#${this.sWrapper}`).remove();
    const sHtml = `
            <section id="${this.sWrapper}" class="popup popup_layer popup_register">
                <header class="popup_header">
                    <h3 class="popup_header_title">상품문의 등록완료</h3>
                    <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                        </svg>
                    </button>
                </header>
                <div class="popup_contents">
                    <article class="popup_inner">
                        <div class="text_area">
                            <strong class="title"><span class="text_color1">상품문의가 등록</span>되었습니다.</strong>
                            <p class="text">업무 시간 외 등록하신 문의 글은 <br>익일 업무 시간 내 순차적으로 처리 예정입니다.</p>
                            <dl class="time">
                                <dt>업무시간 안내</dt>
                                <dd>오전 9시 ~ 오후 6시 (주말, 공휴일 제외)</dd>
                            </dl>
                        </div>
                    </article>
                    <!-- [D] 버튼 -->
                    <div class="popup_buttons">
                        <button type="button" class="popup_button type01" data-role="close">
                        확인
                        </button>
                    </div>
                </div>
            </section>
        `;
    this.welContainer.append(sHtml);
  }
}
